import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="font-display text-white/40 tracking-widest">Wird geladen …</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
